import { Hero } from '../types';
import { escapeHtml, sanitizeUrl } from '../utils/security';

export function buildHero(hero: Hero) {
    const container = document.querySelector('[data-section="hero"]');
    if (!container) return;

    container.innerHTML = `
        <div class="grid lg:grid-cols-[1.05fr_0.95fr] gap-14 items-center pt-[104px] pb-[112px]">
            <div class="animate-fadeUp">
                <div class="flex items-center gap-3 mb-[22px]">
                    <span class="w-[26px] h-0.5 bg-sunset block" aria-hidden="true"></span>
                    <span class="font-mono text-[13px] font-medium tracking-[2px] uppercase text-sunset">${escapeHtml(hero.kicker)}</span>
                </div>
                <h1 class="text-[clamp(42px,5.4vw,62px)] leading-[1.03] font-bold tracking-[-1.5px] text-creme mb-[18px]">
                    ${escapeHtml(hero.name)}
                </h1>
                <p class="text-[22px] leading-tight font-semibold text-sunset mb-[22px]">${escapeHtml(hero.title)}</p>
                <p class="text-lg leading-relaxed text-creme/70 max-w-[34em] mb-[34px]">${escapeHtml(hero.tagline)}</p>

                <div class="flex items-center gap-3 flex-wrap">
                    <a href="#kontakt" class="text-[15px] font-semibold text-graphite-deep bg-sunset rounded-md px-[22px] py-3 inline-flex items-center gap-2 transition-colors hover:bg-sunset-dark">
                        Ta kontakt<i data-lucide="arrow-right" stroke-width="1.5" class="w-4 h-4"></i>
                    </a>
                    ${hero.social.map(s => `
                        <a href="${sanitizeUrl(s.url)}"
                           target="_blank"
                           rel="noopener"
                           aria-label="${escapeHtml(s.label)}"
                           title="${escapeHtml(s.label)}"
                           class="w-[46px] h-[46px] rounded-md border-[1.5px] border-n500 text-creme inline-flex items-center justify-center transition-colors hover:bg-creme/10 hover:border-creme">
                            <i data-lucide="${escapeHtml(s.icon)}" stroke-width="1.5" class="w-5 h-5"></i>
                        </a>
                    `).join('')}
                </div>
            </div>

            <!-- terminal card -->
            <div class="animate-fadeUp bg-[#141518] border border-creme/10 rounded-lg overflow-hidden shadow-lg" style="animation-delay: 0.12s">
                <div class="flex items-center gap-2 px-4 py-[13px] border-b border-creme/[0.07]">
                    <span class="w-[11px] h-[11px] rounded-full bg-[#3a3d42] block"></span>
                    <span class="w-[11px] h-[11px] rounded-full bg-[#3a3d42] block"></span>
                    <span class="w-[11px] h-[11px] rounded-full bg-[#3a3d42] block"></span>
                    <span class="font-mono text-xs text-n400 ml-2">kristian.sh</span>
                </div>
                <div class="px-[22px] pt-[22px] pb-[26px] font-mono text-sm leading-[26px] text-creme">
                    <div><span class="text-n400">$</span> whoami</div>
                    <div>kristian@maelandcc</div>
                    <div class="h-2.5"></div>
                    <div><span class="text-sunset">→</span> Senior Cloud Engineer</div>
                    <div><span class="text-sunset">→</span> Azure · Terraform · Bicep</div>
                    <div><span class="text-sunset">→</span> Platform &amp; Zero Trust</div>
                    <div><span class="text-sunset">→</span> IaC · CI/CD · Entra ID</div>
                    <div class="h-2.5"></div>
                    <div class="text-n400"># 14 år i drift, sky &amp; automatisering</div>
                    <div class="mt-2"><span class="text-n400">$</span> <span class="animate-blink inline-block w-2 h-4 bg-sunset align-[-2px]"></span></div>
                </div>
            </div>
        </div>
    `;
}
